/* Countdown voor de announcement bar. Telt af naar data-eind (ISO-datum).
   Is de datum leeg of voorbij, dan verbergt het element zichzelf. */
class AsnCountdown extends HTMLElement {
  connectedCallback() {
    const eind = this.dataset.eind;
    if (!eind) return this.verberg();
    this.doel = new Date(eind).getTime();
    if (Number.isNaN(this.doel)) return this.verberg();

    this.velden = {
      d: this.querySelector('[data-d]'),
      u: this.querySelector('[data-u]'),
      m: this.querySelector('[data-m]'),
      s: this.querySelector('[data-s]'),
    };
    this.tik();
    this.timer = setInterval(() => this.tik(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }

  verberg() {
    this.hidden = true;
    clearInterval(this.timer);
  }

  tik() {
    const over = this.doel - Date.now();
    if (over <= 0) return this.verberg();

    const s = Math.floor(over / 1000);
    const pad = (n) => String(n).padStart(2, '0');
    if (this.velden.d) this.velden.d.textContent = pad(Math.floor(s / 86400));
    if (this.velden.u) this.velden.u.textContent = pad(Math.floor((s % 86400) / 3600));
    if (this.velden.m) this.velden.m.textContent = pad(Math.floor((s % 3600) / 60));
    if (this.velden.s) this.velden.s.textContent = pad(s % 60);
  }
}

customElements.define('asn-countdown', AsnCountdown);
